export const NATIONAL_SEARCH_PATH =
  process.env.REACT_APP_NATIONAL_SEARCH_PATH || '';
